import { type ReactNode } from "react";

import { usePushNotificationHandlers } from "./hooks/usePushNotificationHandlers";
import { usePushNotificationRegistration } from "./hooks/usePushNotificationRegistration";

interface PushNotificationProviderProps {
  children: ReactNode;
}

/**
 * Provider that handles push notification registration and event handling.
 * Registers the device for push notifications, sends the token to the backend,
 * and wires up notification tap routing, foreground toast display, and deep link handling.
 * Must be mounted inside the authenticated app tree (requires userId from session).
 */
export function PushNotificationProvider(props: PushNotificationProviderProps) {
  const { children } = props;

  usePushNotificationRegistration();
  usePushNotificationHandlers();

  return <>{children}</>;
}
